module.exports = __webpack_public_path__ + "img/number1.dff130ac.jpg";